import request from '@/utils/request'

//10.1 商家店铺分类列表
export function getStoreCategoryList(params) {
  return request({
    url: '/api/seller/store/category',
    method: 'get',
    params
  })
}

//10.2商家店铺列表
export function getStoreList(id,page,pn=8) {
  return request({
    url: '/api/seller/store?cid='+id+'&page='+page+'&pn=4',
    method: 'get'
  })
}

//10.3 商家店铺详情
export function getStoreDetail(id) {
  return request({
    url: '/api/seller/store/'+id,
    method: 'get'
  })
}

//10.4 展品分类列表
export function getProductCategoryList(id) {
  return request({
    url: '/api/seller/product/category/'+id,
    method: 'get'
  })
}

//10.5 展品列表
export function getProductList(id,cid,page) {
  return request({
    url: '/api/seller/'+id+'/product?cid='+cid+'&page='+page+'&pn=3',
    method: 'get'
  })
}

//10.6 商家展品详情页
export function getProductDetail(sid,pid) {
  return request({
    url: '/api/seller/'+sid+'/product/'+pid,
    method: 'get'
  })
}
